export const readCookie = (name: string): string | null => {
    const nameEQ = encodeURIComponent(name) + '=';
    const cookies = document.cookie.split(';');
    let searchedCookie = cookies.find(cookie => cookie.trim().indexOf(nameEQ) === 0);
    if (searchedCookie) {
        searchedCookie = searchedCookie.trim();
        return decodeURIComponent(searchedCookie.substring(nameEQ.length, searchedCookie.length));
    }
    return null;
};

export const setCookie = (name: string, value: unknown): void => {
    const days = 365;
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    let expires = date.toUTCString();
    if (value === null) {
        expires = 'Thu, 01 Jan 1970 00:00:01 GMT';
    }
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/';
};
